import Vue from 'vue'
import Router from 'vue-router'
import LoginForm from '@/components/LoginForm'
import CondenacoesGeolocalizadas from '@/components/CondenacoesGeolocalizadas'
import CondenacoesTotais from '@/components/CondenacoesTotais'
import CondenacoesEvolucao from '@/components/CondenacoesEvolucao'
import DashBoard from '@/components/DashBoard'

Vue.use(Router)

export default new Router({
  routes: [{
      path: '/',
      name: 'LoginForm',
      component: LoginForm
    },
    {
      path: '/DashBoard',
      name: 'DashBoard',
      component: DashBoard
    },
    {
      path: '/CondenacoesTotais',
      name: 'CondenacoesTotais',
      component: CondenacoesTotais
    },
    {
      path: '/CondenacoesGeolocalizadas',
      name: 'CondenacoesGeolocalizadas',
      component: CondenacoesGeolocalizadas
    },
    {
      path: '/CondenacoesEvolucao',
      name: 'CondenacoesEvolucao',
      component: CondenacoesEvolucao
    },
    {
      path: '*',
      name: 'default',
      redirect: DashBoard
    }

  ],
  mode: 'history'
})



// WEBPACK FOOTER //
// ./src/router/index.js